const AccessUv = () => import('@/views/main/fubo/accessUv/AccessUv.vue')
export default {
  path: '/main/fubo/accessUv',
  name: 'fuboAccessUv',
  component: AccessUv,
  children: []
}
